import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app/App.tsx';
import './core/i18n/index.ts';
import * as Sentry from "@sentry/react";
import { applyEnvironmentChrome } from './utils/environment.ts';

Sentry.init({
  dsn: "https://cb4d7029cc9374d3f656380d8d7f5a17@o4508460510412800.ingest.de.sentry.io/4511195155071056",
  sendDefaultPii: true
});

// Marks the tab before anything renders, so a staging window never looks
// like production even for a frame.
applyEnvironmentChrome();

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
